import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ImageService } from '../../../services/image.service';
import { ImageUploadHandlerService } from '../../../../../../shared/services/image-upload-handler.service';
import { FetchProductService } from '../../../services/fetch-product.service';
import { PostProductStepService } from '../../../services/post-product-step.service';
import { ProductStepHandlingService } from '../../../services/product-step-handling.service';
import { FetchProdcutNameService } from '../../../services/fetch-product-name.service';
import { BaseProduct } from '../../../../../../shared/product/baseProduct';
import { ProductTypes } from '../../../../../../shared/product/productTypes';
import { ClaimStepOneComponent } from './components/claim-step-one/claim-step-one.component';
import { ClaimStepTwoComponent } from './components/claim-step-two/claim-step-two.component';
import { ClaimStepThreeComponent } from './components/claim-step-three/claim-step-three.component';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../../../../shared/services/language.service';
import { BasicStepOneTemplateService } from '../../basic-info/services/basic-step-one-template.service';
import { toggleProductExtraInfoFlag } from '../../../../../../shared/utils/productUtils';
declare var $: any;

@Component({
  selector: 'app-claim',
  templateUrl: './claim.component.html',
  styleUrls: ['./claim.component.scss'],
})
export class ClaimComponent
  extends BaseProduct
  implements OnInit, AfterViewInit
{
  @ViewChild(ClaimStepOneComponent) claimStepOne!: ClaimStepOneComponent;
  @ViewChild(ClaimStepTwoComponent) claimStepTwo!: ClaimStepTwoComponent;
  @ViewChild(ClaimStepThreeComponent)
  claimStepThree!: ClaimStepThreeComponent;
  isUpdate: any = false;
  id: any;
  searchableSelectDefaultValue: any;
  productObject: any;
  similarProducts: any[] = [];
  subscriptions: any[] = [];
  productIsCopied: boolean = false;
  isBuyerInfoFormValid = false;
  isNotifyBuyersFormValid = false;
  isSubmitting: boolean = false;
  listCurrentIcon: string = '../../../../../assets/icons/list.svg';
  responsiveCurrentIcon: string = '../../../../../assets/icons/responsive.svg';
  globeCurrentIcon: string = '../../../../../assets/icons/globe.svg';
  listIcon: string = '../../../../../assets/icons/list-muted.svg';
  responsiveIcon: string = '../../../../../assets/icons/responsive-muted.svg';
  globeIcon: string = '../../../../../assets/icons/globe-muted.svg';
  constructor(
    imageUploadRqst: ImageService,
    imageUpload: ImageUploadHandlerService,
    private postStep: PostProductStepService,
    dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private fetchProductService: FetchProductService,
    private fetchProdcutNameService: FetchProdcutNameService,
    public stepHandlerService: ProductStepHandlingService,
    public translate: TranslateService,
    private languageService: LanguageService,
    private basicStepOneTemplateService: BasicStepOneTemplateService
  ) {
    super(imageUpload, imageUploadRqst, dialog);
  }

  async ngOnInit() {
    this.translate.use(localStorage.getItem('language'));
    this.languageService.languageUpdated.subscribe((lang: string) => {
      this.translate.use(lang);
    });
    this.productName = ProductTypes.Collection;
    this.subscriptions.push(
      this.stepHandlerService.currentOrderEvent.subscribe(
        (currentOrder: number) => {
          this.currentStep = currentOrder;
        }
      )
    );
    this.stepHandlerService.isBuyerInfoFormValid.subscribe((value) => {
      this.isBuyerInfoFormValid = value;
    });
    this.stepHandlerService.isNotifyBuyersValid.subscribe((value) => {
      this.isNotifyBuyersFormValid = value;
    });
    this.activatedRoute.params.subscribe(async (params) => {
      if (params['id']) this.isUpdate = true;
    });
  }

  async ngAfterViewInit() {
    await this.claimStepOne.asyncUpdateForm();
    this.activatedRoute.params.subscribe(async (params) => {
      if (params['id']) {
        this.id = params['id'];
        this.fetchProductService.setParams({
          id: this.id,
          type: ProductTypes.Collection,
        });
        this.productObject = await this.fetchProductService.make();
        if (this.isUpdate && this.productObject) {
          toggleProductExtraInfoFlag(this.productObject, 'VATOnSellerFlag');
          this.applyValuesToFields(this.productObject);
        }
      } else {
        const formValue =
          await this.basicStepOneTemplateService.getObjectToPatch(
            this.claimStepOne.productName
          );
        if (formValue) this.claimStepOne.stepForm.patchValue(formValue);
      }
      await this.prepareSimilarProducts();
    });
    // init all product forms for the base components
    this.forms = [this.claimStepOne, this.claimStepTwo, this.claimStepThree];
    this.claimStepOne.from.controls['Payment options'].valueChanges.subscribe(
      () => {
        if (this.currentStep == 1) {
          let paymentOptions =
            this.claimStepOne.from.controls['Payment options'].value;
          if (!paymentOptions || paymentOptions.length < 1) {
            this.claimStepOne.from.controls['Payment options'].setErrors({
              required: true,
            });
            this.claimStepOne.formValidator.forceShowErrors();
          }
        }
      }
    );
  }

  async submit(): Promise<any> {
    try {
      this.isSubmitting = true;
      let stepsValues = JSON.parse(JSON.stringify(this.StepsValue));
      delete stepsValues['Item Name'];
      delete stepsValues['Price'];
      delete stepsValues['Quantity'];
      if (
        !stepsValues['Claim Items'] ||
        stepsValues['Claim Items'].length == 0
      ) {
        this.claimStepTwo.from.controls['Claim Items'].setErrors({
          required: true,
        });
        this.claimStepTwo.formValidator.forceShowErrors();
        this.goToStep(2);
        this.isSubmitting = false;
        return;
      }
      //validation on deposit after the amount is set
      const depositAmount = Number(stepsValues['Do you want Qasatly Deposit?']);
      let itemPrice = Number(stepsValues['Claim Items'][0].Price);
      for (let item of stepsValues['Claim Items']) {
        if (item.Price < itemPrice) itemPrice = item.Price;
      }
      const depositValidation = this.qasatlyDepositValidation(
        this.claimStepOne.stepForm.controls['Do you want Qasatly Deposit?'],
        this.claimStepOne.formValidator,
        itemPrice,
        depositAmount
      );
      if (depositValidation) {
        this.goToStep(1);
        return;
      }
      let productValues = {
        ...stepsValues,
        type: ProductTypes.Collection,
        editing: this.isUpdate,
        productId: this.id,
      };

      if (!productValues['TaxesQuestion']) {
        productValues['Taxes'] = 0;
        productValues['Type'] = '';
      }

      let defaultBuyerInfos = [
        {
          id: '',
          fieldName: 'Name',
          fieldRequired: true,
          fieldType: '1',
          value: [],
        },
        {
          id: '',
          fieldName: 'Email',
          fieldRequired: true,
          fieldType: '1',
          value: [],
        },
        {
          id: '',
          fieldName: 'Phone',
          fieldRequired: true,
          fieldType: '1',
          value: [],
        },
      ];

      productValues['buyersToBeNotified'] =
        JSON.stringify(this.claimStepTwo.claimStepFour.stepFourForm.value) ||
        null;
      let buyerInfos =
        this.claimStepThree.stepForm.controls['buyerInfos'].value ||
        productValues['buyerInfos'];
      let thereIsDublickts = this.claimStepThree.FormBuilder.dublicetIndex > -1;
      if (thereIsDublickts) {
        return null;
      }
      productValues['buyerInfos'] = [...buyerInfos, ...defaultBuyerInfos];
      productValues["Do you want the VAT to be on buyer?"] = !productValues["Do you want the VAT to be on buyer?"];
      this.postStep.setParams(productValues);
      let result = await this.postStep.make();

      //let url = (await window.location.origin) + '/' + result.product.code;
      // await this.openCongratulationDialoug(
      //   url,
      //   productValues['name'],
      //   ProductTypes.Collection,
      //   this.isUpdate
      // );
      // await this.router.navigateByUrl(result.product.code);
      window.location.href = result.product.code + "?showWindow=" + (this.isUpdate ? "update" : "create");
      //window.location.reload();
      this.isSubmitting = false;
    } catch (error) {
      this.isSubmitting = false;
    }
  }

  async prepareSimilarProducts() {
    this.fetchProdcutNameService.setParams({
      filterOptions: {
        published: '1',
        productType: ProductTypes.Collection,
      },
      sortOptions: {
        productName: 'ASC',
      },
    });
    const result = await this.fetchProdcutNameService.make();
    this.similarProducts = result;
  }

  public applyValuesToFields(data: any) {
    let forms = [this.claimStepOne, this.claimStepTwo, this.claimStepThree];
    forms.forEach((form, step) => {
      let fields = form.from.controls;
      let selectDefaultValue: any = {
        id: data.Claim.CollectionsCustomerId,
        description: data.Claim.CollectionsCustomer.customerBusinessName,
      };
      this.searchableSelectDefaultValue = selectDefaultValue;
      Object.keys(fields).forEach((fieldName: string) => {
        let mappedFieldName: string = this.mapNewProductNames(fieldName);
        let value;
        if (fieldName == 'Payment options') {
          value = data[mappedFieldName] || '[]';
        } else if (fieldName == 'Claim name') {
          value = data.productName;
        } else if (fieldName == 'Claim number') {
          value = data.Claim.claimNumber;
        } else if (fieldName == 'Due date') {
          value = data.Claim.dueDate;
        } else if (fieldName == 'Customer') {
          value = data.Claim.CollectionsCustomerId;
        } else {
          if (step == 0) {
            value = this.getNewFieldValueByKey(
              data.ProductExtraInfos,
              mappedFieldName
            );
          }
        }
        if (!value || !form.from.controls[fieldName]) {
          return;
        }

        form.from.controls[fieldName].setValue(value, {emitEvent: true});
        if (data.ProductTax) {
          //console.log(+data.ProductTax.taxes > 0, 'data.ProductTax');
          this.claimStepOne.stepForm.controls['TaxesQuestion'].setValue(
            +data.ProductTax.taxes > 0
          );
          this.claimStepOne.stepForm.controls['Type'].setValue(
            data.ProductTax.type
          );
          this.claimStepOne.stepForm.controls['Taxes'].setValue(
            data.ProductTax.taxes
          );
          this.claimStepOne.isTaxesApplied = +data.ProductTax.taxes > 0;
        } else {
          this.claimStepOne.stepForm.controls['TaxesQuestion'].setValue(false);
          this.claimStepOne.stepForm.controls['Type'].setValue('');
          this.claimStepOne.stepForm.controls['Taxes'].setValue('');
          this.claimStepOne.isTaxesApplied = false;
        }
        if (data.BuyerInfoFields && data.BuyerInfoFields.length > 3) {
          this.isBuyerInfoFormValid = true;
          this.claimStepTwo.stepForm.controls[
            this.claimStepTwo.controllers['is_buyer_info'].fieldName
          ].setValue(true);
        }
      });
    });
    this.claimStepTwo.itemArray = [];
    data.ClaimItems.forEach((ele: any) => {
      //console.log(ele, this.invoiceStepTwo.itemArray);
      this.claimStepTwo.addItem({
        name: ele.name,
        price: ele.price,
        quantity: ele.quantity,
      });
    });
  }
  getNewFieldValueByKey(fieldValues: any[], name: string) {
    return (fieldValues.find((fv) => fv.key === name) || {}).value;
  }
  mapNewProductNames(fieldName: string) {
    switch (fieldName) {
      case 'Claim description':
        return 'description';
      case 'Expiry date':
        return 'expiryDate';
      case 'Due date':
        return 'dueDate';
      case 'Customer':
        return 'name';
      case 'After Payment Message':
        return 'afterPaymentMessage';
      case 'Do you want to show this claim on your shop?':
        return 'showOnShop';
      case 'Currency':
        return 'currency';
      case 'Do you want the fees to be on the buyer?':
        return 'feesOnBuyerFlag';
      case 'Do you want the fees to be split between buyer and seller?':
        return 'splitFees';
      case 'Do you want the VAT to be on buyer?':
        return 'VATOnSellerFlag';
      case 'Do you want to send an SMS to the buyer after purchase? with a cost 0.5 EGP':
        return 'SendSmsFlag';
      case 'Do you want Qasatly Deposit?':
        return 'qasatlyDeposit';
      case 'Payment options':
        return 'paymentOptions';
      case 'Product Image':
        return 'image';
      case 'Category':
        return 'name';
      case 'Product Price':
        return 'price';
      case 'Available Quantity':
        return 'quantity';
      case 'Delivery terms':
        return 'deliveryTerms';
      case 'Return terms':
        return 'returnTerms';
      case 'cash options':
        return 'cashExpiryDate';
      default:
        return '';
    }
  }
  async onProductSelection(event: any) {
    let selectedId = event.target.value;
    this.productIsCopied = true;
    this.fetchProductService.setParams({
      id: selectedId,
      type: ProductTypes.Collection,
    });
    const result = await this.fetchProductService.make();
    this.productObject = result;
    this.applyValuesToFields(this.productObject);
    for (let i = this.currentStep; i > 1; i--) {
      --this.currentStep;
    }
  }

  async goToStep(order: any) {
    let steps;
    if (order < this.currentStep) {
      steps = this.currentStep - order;
      for (let i = steps; i > 0; i--) {
        this.navigateToStep('prev');
      }
    } else if (order > this.currentStep) {
      steps = order - this.currentStep;
      for (let i = steps; i > 0; i--) {
        this.navigateToStep('next');
      }
    }
  }

  get getlastStep() {
    if (this.claimStepTwo) {
      const stepTwoValues = Object.values(this.claimStepTwo.stepForm.value);
      const isHaveBuyerInfoStep = stepTwoValues[0] ? 1 : 0;
      if (isHaveBuyerInfoStep) return 3;
      return 2;
    } else {
      return 2;
    }
  }
  async navigateToStep(navigation: string) {
    if (this.isCurrentStepValid()) {
      const isBeforeTheLastStep = this.isStepBeforeBuyerInfoStep();
      if (isBeforeTheLastStep) {
        if (!this.isNotifyBuyersFormValid) {
          this.claimStepTwo.claimStepFour.formValidator.forceShowErrors();
          return;
        }
        this.getBuyerInfoTogglerChoice();
        if (this.getlastStep == 2 && navigation == 'next') {
          await this.submit();
        } else {
          if (navigation == 'next') {
            ++this.currentStep;
          } else {
            --this.currentStep;
          }
          $('html, body').animate({
            scrollTop: 0,
          });
        }
      } else {
        if (navigation == 'next') {
          ++this.currentStep;
        } else {
          --this.currentStep;
        }
        $('html, body').animate({
          scrollTop: 0,
        });
      }
    } else {
      if (navigation == 'prev') {
        --this.currentStep;
      }
      $('html, body').animate({
        scrollTop: 0,
      });
    }
  }
}
